<template>
  <div :class="{ darkMode: isDarkMode }">
    <vue-snotify></vue-snotify>
    <v-app
      :dark="isDarkMode"
      tabindex="0"
      id="main-shell"
      v-bind:class="{ 'main-scroll': isFullscreen }"
    >
      <v-navigation-drawer
        v-model="drawer"
        v-if="!isFullscreen && !expiredDialog"
        fixed
        right
        app
        v-bind:disable-resize-watcher="true"
      >
        <v-list dense class="top-high">
          <v-list-tile v-on:click="changePage('/admin/dashboard')">
            <v-list-tile-content>
              <v-switch
                @change="toggleDarkMode"
                color="red lighten-3"
                label="Dark mode"
                v-model="isDarkMode"
              ></v-switch>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-on:click="changePage('/admin/dashboard')">
            <v-list-tile-content>
              <v-list-tile-title>{{
                getString("Dashboard")
              }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-group>
            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title>{{
                  getString("Calendario")
                }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              v-for="(item, index) in shops"
              :key="index"
              @click="changePage('/admin/calendar/')"
            >
              <v-list-tile-title>{{ item.name }}</v-list-tile-title>
            </v-list-tile>
          </v-list-group>
          <v-list-group>
            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title>{{
                  getString("Negozio")
                }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              v-for="(item, index) in shops"
              :key="index"
              @click="changePage('/admin/shops/details')"
            >
              <v-list-tile-title>{{ item.name }}</v-list-tile-title>
            </v-list-tile>
          </v-list-group>
          <v-list-tile v-on:click="changePage('/admin/fid')">
            <v-list-tile-content>
              <v-list-tile-title>{{
                getString("Fidelity card")
              }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-on:click="changePage('/admin/me')">
            <v-list-tile-content>
              <v-list-tile-title>{{ getString("Profilo") }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="changePage('/admin/payments')">
            <v-list-tile-content>
              <v-list-tile-title>{{
                getString("Pagamenti")
              }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="changePage('/admin/about')">
            <v-list-tile-content>
              <v-list-tile-title>{{ getString("Info") }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-group>
            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title>{{
                  getString("Comunicazioni")
                }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile @click="changePage('/admin/com')">
              <v-list-tile-content>
                <v-list-tile-title>{{ getString("Comunicazioni") }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile @click="changePage('/admin/autonotifications')">
              <v-list-tile-content>
                <v-list-tile-title>{{ getString("Notifiche automatiche") }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>
          <v-list-tile v-if="isAdmin" @click="changePage('/admin/manager')">
            <v-list-tile-content>
              <v-list-tile-title>{{
                getString("Amministrazione")
              }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-if="isAdmin" @click="changePage('/admin/comm')">
            <v-list-tile-content>
              <v-list-tile-title>{{
                getString("Comunicazioni")
              }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-if="isAdmin" @click="changePage('/admin/diag')">
            <v-list-tile-content>
              <v-list-tile-title>{{
                getString("Diagnostica")
              }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-if="isAdmin" v-on:click="changePage('/admin/server')">
            <v-list-tile-content>
              <v-list-tile-title v-if="isAdmin">{{
                getString("Server")
              }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="logout">
            <v-list-tile-content>
              <v-list-tile-title>{{ getString("Esci") }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-navigation-drawer>
      <v-toolbar
        v-show="!isFullscreen && !expiredDialog"
        style="z-index: 6"
        class="elevation-3"
        fixed
        app
      >
        <v-flex style="margin-top: 22px">
          <v-toolbar-title
            style="cursor: default; display: flex"
            class="shell-title"
          >
            <img src="../../../static/img/logo.png" class="shell-logo" />
            <v-btn
              style="margin-top: 11px; border-radius: 5px"
              @click="openChangeLogDialog"
              :class="{ 'update-incoming': updateAlert }"
              >{{ getString(updateAlert ? "Novità" : "Aggiornamenti") }}</v-btn
            >
            <v-layout style="margin-top: 12px" hidden-sm-and-down>
              <v-switch
                @change="toggleDarkMode"
                color="red lighten-3"
                label="Dark mode"
                v-model="isDarkMode"
              ></v-switch>
            </v-layout>
            <!-- <v-btn
              style="margin-top: 11px; border-radius: 5px"
              @click="toggleDarkMode"
              >{{ getString("Dark Mode") }}</v-btn
            > -->
            <!-- <span class="shell-title">
              {{ getString("Ciao ") }}{{ userName }}</span
            > -->
          </v-toolbar-title>
        </v-flex>
        <v-spacer></v-spacer>
        <v-toolbar-items class="hidden-sm-and-down">
          <v-tooltip bottom>
            <v-btn
              slot="activator"
              flat
              href="/admin/dashboard"
              v-on:click.prevent="changePage('/admin/dashboard')"
              >{{ getString("Dashboard") }}</v-btn
            >
            <span>{{ getString("Le tue statistiche") }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-menu offset-y slot="activator">
              <v-btn
                flat
                slot="activator"
                @click.middle="openTab(shops, 'calendar')"
                v-on:click="checkNumShops(shops, 'calendar')"
                >{{ getString("Calendario") }}</v-btn
              >
              <v-list v-show="shops.length > 1">
                <v-list-tile
                  @click="changePage('/admin/calendar/')"
                  v-for="(item, index) in shops"
                  :key="index"
                >
                  <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
            <span>{{ getString("Gestisci il tuo calendario") }}</span>
          </v-tooltip>
          <!-- <v-tooltip bottom>
                    <v-menu offset-y slot="activator">
                        <v-btn flat slot="activator" @click.middle="openTab(shops, 'shops')" v-on:click="checkNumShops(shops, 'shops')">{{getString('Negozio')}}</v-btn>
                    </v-menu>
                    <span>{{getString('Gestisci i tuoi negozi')}}</span>
          </v-tooltip>-->
          <!-- <v-tooltip bottom>
                    <v-btn flat slot="activator" href='/admin/ecommerce' v-on:click.prevent="changePage('/admin/ecommerce')">{{getString('E-Commerce')}}</v-btn><span>{{getString('Gestisci il tuo E-commerce')}}</span>
          </v-tooltip>-->
          <v-menu offset-y open-on-hover>
            <v-btn slot="activator" flat>{{ getString("Negozio") }}</v-btn>
            <v-list v-if="shops.length === 1">
              <v-list-tile
                v-for="(item, index) in [
                  {
                    title: getString('Gestisci'),
                    url: '/admin/shops/details',
                    popup: getString('Il tuo negozio'),
                  },
                  {
                    title: getString('Fidelity card'),
                    url: '/admin/fid',
                    popup: getString('Gestisci la tua carta'),
                  },
                  /*  {
                    title: getString('Quick Calendar!'),
                    url: '/admin/quickcal',
                    popup: getString('Il tuo calendario da smartphone!'),
                  },*/
                ]"
                :key="index"
              >
                <v-tooltip left class="full-tooltip">
                  <v-btn
                    block
                    flat
                    slot="activator"
                    :href="item.url"
                    v-on:click.prevent="changePage(item.url)"
                    >{{ getString(item.title) }}</v-btn
                  >
                  <span>{{ getString(item.popup) }}</span>
                </v-tooltip>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-menu offset-y open-on-hover>
            <v-btn slot="activator" flat>{{ getString("Comunicazioni") }}</v-btn>
            <v-list>
              <v-list-tile
                v-for="(item, index) in [
                  {
                    title: getString('Comunicazioni'),
                    url: '/admin/com',
                    popup: 'Comunicazioni importanti!',
                  },
                  {
                    title: getString('Notifiche automatiche'),
                    url: '/admin/autonotifications',
                    popup: 'Gestisci notifiche automatiche',
                  },
                ]"
                :key="index"
              >
                <v-tooltip left class="full-tooltip">
                  <v-btn
                    block
                    flat
                    slot="activator"
                    :href="item.url"
                    v-on:click.prevent="changePage(item.url)"
                    >{{ getString(item.title) }}</v-btn
                  >
                  <span>{{ getString(item.popup) }}</span>
                </v-tooltip>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-menu offset-y open-on-hover>
            <v-btn slot="activator" flat>{{ getString("I miei dati") }}</v-btn>
            <v-list>
              <v-list-tile
                v-for="(item, index) in [
                  {
                    title: getString('Profilo'),
                    url: '/admin/me',
                    popup: 'Il tuo profilo personale',
                  },
                  {
                    title: getString('Pagamenti'),
                    url: '/admin/payments',
                    popup: 'Vedi lo stato dei pagamenti',
                  },
                ]"
                :key="index"
              >
                <v-tooltip left class="full-tooltip">
                  <v-btn
                    block
                    flat
                    slot="activator"
                    :href="item.url"
                    v-on:click.prevent="changePage(item.url)"
                    >{{ getString(item.title) }}</v-btn
                  >
                  <span>{{ getString(item.popup) }}</span>
                </v-tooltip>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-menu v-if="isAdmin" offset-y open-on-hover>
            <v-btn slot="activator" flat>{{ getString("Gestione") }}</v-btn>
            <v-list>
              <v-list-tile
                v-for="(item, index) in [
                  {
                    title: getString('Amministrazione'),
                    url: '/admin/manager',
                    popup: 'Esercenti, account, utenza, etc.',
                  },
                  {
                    title: getString('Comunicazioni'),
                    url: '/admin/comm',
                    popup: 'Comunicazioni globali',
                  },
                  {
                    title: getString('Diagnostica'),
                    url: '/admin/diag',
                    popup: 'Debugging e modalità avanzate',
                  },
                  {
                    title: getString('Server'),
                    url: '/admin/server',
                    popup: 'Il server corrente di QuickBe',
                  },
                ]"
                :key="index"
              >
                <v-tooltip left class="full-tooltip">
                  <v-btn
                    block
                    flat
                    slot="activator"
                    v-if="isAdmin"
                    :href="item.url"
                    v-on:click.prevent="changePage(item.url)"
                    >{{ getString(item.title) }}</v-btn
                  >
                  <span>{{ getString(item.popup) }}</span>
                </v-tooltip>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-tooltip bottom>
            <v-btn
              flat
              slot="activator"
              href="/admin/about"
              v-on:click.prevent="changePage('/admin/about')"
              >{{ getString("Info") }}</v-btn
            >
            <span>{{ getString("Chi ha fatto QuickBe? :)") }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn flat slot="activator" @click="logout">{{
              getString("Esci")
            }}</v-btn>
            <span>{{ getString("Ci abbandoni? :(") }}</span>
          </v-tooltip>
        </v-toolbar-items>
        <v-toolbar-side-icon
          class="hidden-md-and-up"
          @click.stop="drawer = !drawer"
        ></v-toolbar-side-icon>
      </v-toolbar>
      <v-content id="main-content" v-if="!mustValidate && !expiredDialog">
        <v-container fluid>
          <router-view
            @siteAlert="showAlert"
            @siteAlertSuccess="showAlertSuccess"
            @siteAlertInfo="showAlertInfo"
            @shopsMenu="getShops"
            @getShopsForChildren="getLocalShops"
          ></router-view>
        </v-container>
      </v-content>
      <v-footer app dark v-show="!isFullscreen" style="z-index: 6">
        <v-tooltip top>
          <v-flex slot="activator" class="hidden-sm-and-down">
            <span>
              &nbsp;&nbsp;&copy;&nbsp;{{ new Date().getFullYear() }}
              &nbsp;&nbsp;-&nbsp;&nbsp; QuickBe by
              <a href="https://www.dewstudio.eu">Dew Studio</a>
            </span>
          </v-flex>
          <span>Software Samurai</span>
        </v-tooltip>
        <v-spacer></v-spacer>
        <!-- <v-btn flat v-on:click="toolsBar = !toolsBar">{{getString('Barra degli strumenti')}}</v-btn> -->
        <v-tooltip top>
          <v-btn flat @click="mario" slot="activator">
            <v-icon></v-icon>
          </v-btn>
          <span>{{ getString("BUDUKA!") }}</span>
        </v-tooltip>
        <v-tooltip top>
          <v-btn
            @click="changePage('/admin/marketing')"
            flat
            slot="activator"
            >{{ getString("Marketing") }}</v-btn
          >
          <span>{{ getString("Materiale per il marketing") }}</span>
        </v-tooltip>
        <v-tooltip top>
          <v-btn @click="changePage('/admin/tutorial')" flat slot="activator">{{
            getString("Guida")
          }}</v-btn>
          <span>{{ getString("Impara ad usare QuickBe") }}</span>
        </v-tooltip>
        <v-tooltip top>
          <v-btn
            v-if="isFakeUser"
            flat
            slot="activator"
            @click="logoutFakeUser"
            >{{ getString("Esci da FU") }}</v-btn
          >
          <span>{{ getString("Torna all'admin") }}</span>
        </v-tooltip>
        <v-btn flat @click="supportDialog = !supportDialog">{{
          getString("Supporto")
        }}</v-btn>
      </v-footer>
      <!-- <v-snackbar v-model="alert" bottom multi-line right :timeout="dyncamicAlertTime" color="red darken-4">
        {{ alertText }}
        <v-btn class="q-text-whitesmoke" flat @click="alert = false">
            {{getString("Chiudi")}}
        </v-btn>
    </v-snackbar>
    <v-snackbar v-model="alertSuccess" bottom multi-line right :timeout="dyncamicAlertTime" color="green lighten-1">
        {{ alertTextSuccess }}
        <v-btn class="q-text-whitesmoke" flat @click="alertSuccess = false">
            {{getString("Chiudi")}}
        </v-btn>
    </v-snackbar>
    <v-snackbar v-model="alertInfo" bottom multi-line right :timeout="dyncamicAlertTime" color="blue lighten-1">
        {{ alertTextInfo }}
        <v-btn class="q-text-whitesmoke" flat @click="alertInfo = false">
            {{getString("Chiudi")}}
        </v-btn>
      </v-snackbar>-->
      <v-snackbar
        :class="{ 'full-snackbar': isFullscreen }"
        v-model="toolsBar"
        bottom
        :timeout="0"
        color="grey darken-2"
      >
        <v-tooltip top>
          <v-btn
            class="q-text-whitesmoke"
            slot="activator"
            :disabled="isFullscreen"
            flat
            @click="toogleFullscreen"
          >
            <v-icon x-large>fullscreen</v-icon>
          </v-btn>
          <span>{{ getString("Modalità schermo intero") }}</span>
        </v-tooltip>
        <v-tooltip top>
          <v-btn
            class="q-text-whitesmoke"
            slot="activator"
            :disabled="!isFullscreen"
            flat
            @click="toogleFullscreen"
          >
            <v-icon x-large>fullscreen_exit</v-icon>
          </v-btn>
          <span>{{ getString("Esci da schermo intero") }}</span>
        </v-tooltip>
        <v-tooltip top>
          <v-btn
            class="q-text-whitesmoke"
            slot="activator"
            flat
            @click="alertSuccess = false"
          >
            <v-icon x-large>volume_up</v-icon>
          </v-btn>
          <span>{{
            getString("Per i geni di Apple. Attiva audio su ipad o smartphone")
          }}</span>
        </v-tooltip>
        <v-spacer></v-spacer>
        <v-tooltip top>
          <v-btn
            slot="activator"
            class="q-text-whitesmoke"
            :disabled="isFullscreen"
            flat
            @click="toolsBar = false"
          >
            <v-icon x-large>arrow_drop_down</v-icon>
          </v-btn>
          <span>{{ getString("Nascondi") }}</span>
        </v-tooltip>
      </v-snackbar>
      <audio
        hidden
        ref="soundNotify"
        preload="none"
        class="hidden"
        controls="controls"
      >
        <source :src="selectedSound" />
      </audio>

      <v-dialog v-model="changePageDialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">{{
            getString("Modifiche in corso")
          }}</v-card-title>
          <v-card-text>{{
            getString(
              "Hai modifiche non salvate sulla pagina, vuoi davvero cambiarla e perderle?"
            )
          }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              flat
              @click.native="changePageDialog = false"
              >{{ getString("Torna alla pagina") }}</v-btn
            >
            <v-btn
              color="green darken-1"
              flat
              @click.native="forceChangePage"
              >{{ getString("Prosegui") }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="supportDialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">{{
              getString("Richiesta di supporto")
            }}</span>
          </v-card-title>
          <v-card-text>
            <label>{{
              getString(
                `Hai bisogno d'aiuto? Contattaci usando il seguente form o usando i contatti in sott'impressione!`
              )
            }}</label>
            <v-container>
              <v-layout wrap>
                <v-flex xs12 sm12 lg12 md12>
                  <v-textarea
                    solo
                    v-bind:label="getString('Corpo del messaggio')"
                    v-model="supportMessage"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
            <p>
              <b>{{ getString("Dew Studio ") }}</b>
            </p>
            <p>
              {{
                getString(
                  `Nel caso di problemi con l'invio del modulo, puoi anche usare la seguente email`
                )
              }}
            </p>
            <p>
              <b>E-Mail:</b>
              <a href="mailto:info@quickbe.app">info@quickbe.app</a>
            </p>
          </v-card-text>
          <v-card-actions>
            <v-btn
              class="q-orange"
              flat
              @click.native="supportDialog = false"
              >{{ getString("Chiudi") }}</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              class="q-orange"
              :disabled="loadSupport"
              flat
              @click.native="sendSupportMessage"
              >{{ getString("Invia") }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="changeLogDialog" max-width="1000px">
        <v-card>
          <v-card-title>
            <span class="headline">Aggiornamenti</span>
          </v-card-title>
          <v-card-text>
            <change-log
              @currentRelease="
                (v) => {
                  currentVersioneChangelog = v;
                }
              "
            />
          </v-card-text>
          <v-card-actions>
            <v-btn
              class="q-orange"
              flat
              @click.native="changeLogDialog = false"
              >{{ getString("Chiudi") }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="communicationDialogComputed" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ communication.title }}</span>
          </v-card-title>
          <v-card-text>
            <span v-html="communication.message"></span>
          </v-card-text>
          <v-card-actions>
            <v-btn
              class="q-orange"
              flat
              @click.native="communicationDialog = false"
              >{{ getString("Chiudi") }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="mustValidate" :fullscreen="true" :persistent="true">
        <v-card>
          <v-img
            src="../../../static/img/logo.png"
            height="200"
            contain
          ></v-img>
          <v-card-title primary-title style="text-align: center">
            <div style="max-width: 800px; margin: auto">
              <div class="headline">{{ getString("Ciao!") }}</div>
              <span style="max-width: 500px" class="grey--text">{{
                getString(
                  "Prima di poter utilizzare QuickBe, è importante che tu accetti a i termini del trattamento dati e delle condizioni d'uso. I link portano alla relativa documentazione."
                )
              }}</span>
              <div style="text-align: left; margin-top: 20px">
                <v-checkbox
                  style="display: inline-block"
                  v-model="acceptGDPR"
                ></v-checkbox>
                <p style="display: block; margin-left: 30px; margin-top: -46px">
                  {{ getString("Accetto i ") }}
                  <a href="/legal/eula" target="_new">{{
                    getString("Termini e condizioni per la usufruizione (EULA)")
                  }}</a>
                  <br />
                </p>
              </div>
              <div style="text-align: left; margin-top: 20px">
                <v-checkbox
                  style="display: inline-block"
                  v-model="acceptEULA"
                ></v-checkbox>
                <p style="display: block; margin-left: 30px; margin-top: -46px">
                  {{ getString("Accetto i ") }}
                  <a href="/legal/tecb" target="_new">{{
                    getString("Condizioni trattamento dati (G.D.P.R.)")
                  }}</a>
                </p>
              </div>
              <br />
              <br />
              <v-btn
                @click="sendAcceptTerms"
                :disabled="!acceptGDPR || !acceptEULA || loadTerms"
                class="q-orange-bk q-text-whitesmoke"
                >{{ getString("Entra in QuickBe :)") }}</v-btn
              >
            </div>
          </v-card-title>
        </v-card>
      </v-dialog>
      <v-dialog v-model="showExpiringDialog" persistent max-width="700">
        <v-card class="text-center red q-text-whitesmoke">
          <v-card-title class="headline">{{
            getString("ATTENZIONE")
          }}</v-card-title>
          <v-card-text>
            <h1>
              {{
                getString(
                  "Il tuo abbonamento scadrà fra " + expiringDays + " giorni"
                )
              }}
            </h1>
            <h2>
              {{
                getString(
                  "Rinnovalo subito per evitare la sospensione del servizio."
                )
              }}
            </h2>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click.native="() => (showExpiringDialog = false)">{{
              getString("Chiudi")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="expiredDialog" persistent max-width="700" height="400">
        <v-card class="text-center red q-text-whitesmoke">
          <v-card-title class="headline">{{
            getString("ATTENZIONE")
          }}</v-card-title>
          <v-card-text>
            <h1><b>{{ getString("Il tuo abbonamento è scaduto") }}</b></h1>
            <h2>
              {{ getString("Rinnovalo subito per ripristinare il servizio.") }}
            </h2>
          </v-card-text>
          <v-card-actions >
            <v-spacer></v-spacer>
            <v-btn v-if="isFakeUser" @click.native="() => (expiredDialog = false)">{{
              getString("Chiudi")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-app>
    <div :class="{ mario: marioEnabled }"></div>
  </div>
</template>

<script>
import Utils from "../../utils.js";
import ajax from "../../ajax.js";
import ChangeLog from "../utils/ChangeLog";
import moment from "moment";
var ut = new Utils();
export default {
  name: "Shell",
  components: {
    ChangeLog,
  },
  mounted: function () {
             
    //window.location.href = "https://portale2.quickbe.app/silent-login?token=" + this.$store.getters.token;
    localStorage.setItem(
      "lastRefresh",
      moment().format("YYYY-MM-DD[T]HH:mm:ss")
    );
    setInterval(this.initCheckUpdate, 300000);
    let message = this.$route.query.msg;
    // if (message !== undefined) {
    //     this.showAlert(message);
    // }
    message = this.$route.query.imsg;
    if (message !== undefined) {
      this.showAlertSuccess(message);
    }
    if (this.$store.getters.isLogged) {
      this.$router.push("/admin");
    }

    this.$store.commit("notIsModifying");
    this.getShops();
    this.getLastCommunication();

  },
  watch: {
    expiringDays: function () {
      if (this.expiringDays < 7 && this.expiringDays > 0) {
        this.showExpiringDialog = true;
      }
    },
    shops: function () {
      if (this.$store.getters.myShop !== null)
      {  
        this.expiredDialog = this.$store.getters.myShop.isExpired;
        var selectedShop = this.$store.getters.myShop.idBarberShop;
        ajax.axios
          .get(ajax.baseUrl() + "/admin/shops/shop/" + selectedShop + "/options", {
            headers: this.$store.getters.tokenHeader,
            withCredentials: true,
          })
          .then((response) => {
            ajax.validateToken(response.headers, this.$store);
            const opt = response.data.data || response.data;
            const enabled = opt && (opt.NewPanel === true || opt.newPanel === true || opt.NewPanel === "True" || opt.newPanel === "True");
            if (enabled) {
              // redirect to silent-login for new panel
              window.location.href = "https://portale2.quickbe.app/silent-login?token=" + this.$store.getters.token;
            }
          })
          .catch(() => {});
      }
    },
  },
  computed: {
    expiringDays: function () {
      if (this.$store.getters.myShop !== null)
        return moment(this.$store.getters.myShop.expired).diff(
          moment(),
          "days"
        );
      return 0;
    },
    selectedSound: function () {
      return "../../../../static/audio/crash.wav";
    },
    communicationDialogComputed: function () {
      return this.communicationDialog && !this.mustValidate;
    },
    mustValidate: function () {
      return this.acceptTerms === 2;
    },

    isFullscreen: function () {
      return this.$store.state.isFullscreen;
    },
    userName: function () {
      if (
        this.$store.getters.fakeUser == "" ||
        this.$store.getters.fakeUser == null
      ) {
        if (this.$store.getters.tokenObject !== null) {
          return this.$store.getters.tokenObject.SiteUserName;
        }
      } else {
        return this.$store.getters.fakeUserName;
      }
    },
    isAdmin: function () {
      return this.$store.getters.isAdmin;
    },
    isFakeUser: function () {
      return this.$store.getters.isFakeUser;
    },
    updateAlert: function () {
      if (this.readVerChangeLog != this.currentVersioneChangelog) {
        return true;
      }
      return false;
    },
  },
  data: () => {
    return {
      showExpiringDialog: false,
      expiredDialog: false,
      readVerChangeLog: localStorage.getItem("changeLog"),
      currentVersioneChangelog: localStorage.getItem("changeLog"),
      changeLogDialog: false,
      drawer: false,
      alertText: "",
      alertTextSuccess: "",
      alertTextInfo: "",
      alertSuccess: false,
      alertInfo: false,
      alert: false,
      supportDialog: false,
      changePageDialog: false,
      supportMessage: "",
      toolsBar: false,
      tempRoute: null,
      marioEnabled: false,
      shops: [],
      communicationDialog: false,
      communication: {
        title: "",
        message: "",
      },
      acceptTerms: 1,
      acceptEULA: false,
      acceptGDPR: false,
      loadTerms: false,
      loadSupport: false,
      isDarkMode: localStorage.getItem("darkMode") ? true : false,
    };
  },
  methods: {
    initCheckUpdate: function () {
      const date = localStorage.getItem("lastRefresh");
      const lastRefresh = moment(date);
      const diffDateHours = moment().diff(lastRefresh, "hours");
      if (diffDateHours > 24) location.reload();
    },
    toggleDarkMode: function () {
      localStorage.setItem("darkMode", this.isDarkMode ? true : "");
      // this.isDarkMode = !this.isDarkMode;
    },
    openChangeLogDialog: function () {
      localStorage.setItem("changeLog", this.currentVersioneChangelog);
      this.readVerChangeLog = this.currentVersioneChangelog;
      this.changeLogDialog = true;
    },
    playAudio: function () {
      this.$refs.soundNotify.load();
      this.$refs.soundNotify.play();
    },
    mario: function () {
      let self = this;
      setTimeout(function () {
        self.playAudio();
      }, 1000);
      if (this.marioEnabled) this.marioEnabled = false;
      else {
        this.marioEnabled = true;
        setTimeout(function () {
          self.marioEnabled = false;
        }, 10000);
      }
    },
    sendSupportMessage: function () {
      let self = this;
      this.loadSupport = true;
      let shopNameByStore = "not defined";
      if (this.$store.getters.myShop !== null)
        shopNameByStore = this.$store.getters.myShop.name;
      ajax.axios
        .put(
          ajax.baseUrl() + "/admin/man/sendsupport",
          {
            message: self.supportMessage,
            name: shopNameByStore,
          },
          {
            headers: self.$store.getters.tokenHeader,
            withCredentials: true,
          }
        )
        .then(function (response) {
          self.loadSupport = false;
          self.showAlertSuccess(response.data.data);
          self.supportDialog = false;
        })
        .catch(function (error) {
          self.loadSupport = false;
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.loading = false;
          self.showAlert(
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    sendAcceptTerms: function () {
      let self = this;
      this.loadTerms = true;
      ajax.axios
        .put(
          ajax.baseUrl() + "/admin/user/acceptterms",
          {},
          {
            headers: self.$store.getters.tokenHeader,
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.acceptTerms = 1;
          self.loadTerms = false;
          self.showAlertSuccess(self.getString("Benvenuto in QuickBe!"));
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.loading = false;
          self.showAlert(
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    getLocalShops() {
      return this.shops;
    },
    getShops: function () {
      let self = this;
      this.loading = true;
      ajax.axios
        .get(ajax.baseUrl() + "/admin/shops/getmyshops/", {
          headers: self.$store.getters.tokenHeader,
          withCredentials: true,
        })
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          if (
            response.headers["validate-token"] !== undefined &&
            response.headers["validate-token-message"] !== undefined
          ) {
            self.showAlertNoTime(response.headers["validate-token-message"]);
          }
          //   if (response.data.data.msg !== "")
          //     self.showAlertNoTime(response.data.data.msg);
          self.shops = response.data.data.shops;
          self.acceptTerms = Number.parseInt(response.data.data.accept);
          self.$store.commit("setUserShops", self.shops);
          self.loading = false;
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.loading = false;
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    getLastCommunication: function () {
      let self = this;
      ajax.axios
        .get(ajax.baseUrl() + "/admin/communication/last/", {
          headers: self.$store.getters.tokenHeader,
          withCredentials: true,
        })
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          if (response.data.data != null) {
            self.communication = response.data.data;
            let last = localStorage.getItem("lastComSeen");

            if (Number.parseInt(last) !== self.communication.idCommunication) {
              self.communicationDialog = true;
              localStorage.setItem(
                "lastComSeen",
                self.communication.idCommunication
              );
            }
          }
        })
        .catch(function (error) {
          let auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },

    getString: function (key) {
      let page = this.$store.state.currentTranslator.getString(key);
      return page;
    },
    dyncamicAlertTime: function (text) {
      if (text !== undefined) {
        return text.length * 100 > 3000 ? text.length * 100 : 3000;
      }
      return 3000;
    },
    showAlertSuccess: function (text) {
      this.$snotify.config.global.maxOnScreen = 10;
      this.$snotify.config.global.newOnTop = false;
      this.$snotify.success(text, this.getString("Ok!"), {
        timeout: this.dyncamicAlertTime(text),
        showProgressBar: true,
        bodyMaxLength: 1000,
        closeOnClick: true,
        pauseOnHover: true,
        icon: false,
      });
      //   this.alertTextSuccess = text
      //   this.alertSuccess = !this.alertSuccess
    },
    showAlertInfo: function (text) {
      this.$snotify.config.global.maxOnScreen = 10;
      this.$snotify.config.global.newOnTop = false;
      this.$snotify.info(text, this.getString("Guarda qui!"), {
        timeout: this.dyncamicAlertTime(text),
        showProgressBar: true,
        bodyMaxLength: 1000,
        closeOnClick: true,
        pauseOnHover: true,
        icon: false,
      });
    },
    showAlert: function (text) {
      this.$snotify.config.global.maxOnScreen = 10;
      this.$snotify.config.global.newOnTop = false;
      this.$snotify.error(text, this.getString("Attenzione!"), {
        timeout: this.dyncamicAlertTime(text),
        bodyMaxLength: 1000,
        showProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        icon: false,
      });
    },
    showAlertNoTime: function (text) {
      this.$snotify.config.global.maxOnScreen = 10;
      this.$snotify.config.global.newOnTop = false;
      this.$snotify.error(text, this.getString("Attenzione!"), {
        timeout: 0,
        bodyMaxLength: 1000,
        showProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        icon: false,
      });
    },
    logout: function (text) {
      this.$store.commit("resetToken");
      this.$router.push(
        "/admin/login/?imsg=" + this.getString("Logout effettuato con successo")
      );
    },
    logoutFakeUser: function () {
      this.$store.commit("setfakeUser", null);
    },
    checkNumShops: function (shops, to) {
      if (shops.length == 1) {
        this.changePage("/admin/" + to + "/");
      }
    },
    openTab: function (shops, to) {
      if (shops.length == 1) {
        window.open("/admin/" + to + "/");
      }
    },
    changePage: function (route) {
      //Si dovrebbe controllare che il token è valido lato server
      let mod = this.$store.state.modifying;
      if (!mod) {
        this.$router.push(route);
      } else {
        this.changePageDialog = true;
        this.tempRoute = route;
      }
    },
    forceChangePage: function () {
      this.$store.commit("notIsModifying");
      this.changePageDialog = false;
      let temp = this.tempRoute;
      this.tempRoute = null;
      this.$router.push(temp);
    },
    toogleFullscreen: function () {
      let element = document.getElementById("cal-container");
      if (!this.isFullscreen) {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else {
          if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
          } else {
            if (element.webkitRequestFullscreen) {
              element.webkitRequestFullscreen();
            } else {
              if (element.msRequestFullscreen) {
                element.msRequestFullscreen();
              }
            }
          }
        }
      } else {
        if (document.exitFullscreen) document.exitFullscreen();
        else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
        else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
        else if (document.msExitFullscreen) document.msExitFullscreen();
      }
      this.$store.commit("toggleFullscreen");
    },
    scroll: function (a) {},
  },
};
</script>

<style>
.full-tooltip {
  width: 100% !important;
}

.q-dark-bk {
  background-color: #424242 !important;
}

.q-dark-text {
  color: #f5f5f5 !important;
}

.q-light-bk {
  color: #f5f5f5 !important;
}

.q-light-text {
  color: #424242 !important;
}

.full-width {
  width: 100% !important;
}

h1,
h2,
h3 {
  font-weight: 500;
}

.update-incoming {
  animation-name: updateAlertAnimation !important;
  animation-timing-function: linear !important;
  animation-duration: 1.5s !important;
  animation-iteration-count: infinite !important;
}

@keyframes updateAlertAnimation {
  0% {
    background-color: transparent;
  }

  50% {
    background-color: orange;
  }

  100% {
    background-color: transparent;
  }
}

.full-snackbar {
  margin-bottom: -25px;
  transition: margin-bottom 0.2s linear;
  -o-transition: margin-bottom 0.2s linear;
  -ms-transition: margin-bottom 0.2s linear;
  -webkit-transition: margin-bottom 0.2s linear;
  -moz-transition: margin-bottom 0.2s linear;
}

.full-snackbar:hover {
  margin-bottom: 0px;
}

.shell-title {
  padding-left: 20px;
  line-height: 60px;
  margin-bottom: 22px;
  display: flex;
}

.shell-logo {
  height: 60px;
  display: flex;
}

.no-cradius {
  border-radius: 0 !important;
}

.main-scroll {
  overflow: scroll;
}

.module-closed {
  transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
}

.mario {
  position: fixed;
  z-index: 100;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: transparent;
  background-image: url("../../../static/img/crash.gif") !important;
  background-repeat: no-repeat !important;
  background-position-y: 100% !important;
  background-size: 100px !important;
  animation-name: marioAnimation !important;
  animation-timing-function: linear !important;
  animation-duration: 10s !important;
  animation-iteration-count: 1 !important;
  height: 100px;
  transform: rotateY(180deg);
}

.top-high {
  margin-top: 70px;
}

@keyframes marioAnimation {
  0% {
    background-position-x: 120%;
  }

  100% {
    background-position-x: -20%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/backend/Shell.vue